module.exports = require("vue-i18n");